import { defineStore } from 'pinia';
import { pickBy } from 'lodash';
import {
  ReportListFilter,
  ReportListFilterFields,
  DEFAULT_FILTER_FORM_DATA,
} from '@/models/report/report-list-filter.model';
import { GroupByDate } from '@/models/app-common/app-common.model';

type MgaReportListFilterState = {
  isFilterVisible: boolean;
  isFilterActive: boolean;
  filterFormData: ReportListFilter;
  submittedFilterFormData: ReportListFilter;
  activeFiltersCount: number;
  reportPeriod: GroupByDate;
};

export const useMgaReportListFilterStore = defineStore({
  id: 'MgaReportListFilterStore',
  state: (): MgaReportListFilterState => ({
    isFilterVisible: false,
    isFilterActive: false,
    filterFormData: {
      ...DEFAULT_FILTER_FORM_DATA,
    },
    submittedFilterFormData: {
      ...DEFAULT_FILTER_FORM_DATA,
    },
    activeFiltersCount: 1,
    reportPeriod: GroupByDate.MONTH,
  }),
  getters: {
    filterFormDataLength: (state) => Object.keys(state.submittedFilterFormData).length,
  },
  actions: {
    setIsFilterVisible(isVisible: boolean): void {
      this.isFilterVisible = isVisible;
    },
    setIsFilterActive(isActive: boolean): void {
      this.isFilterActive = isActive;
    },
    setReportPeriod(): void {
      this.reportPeriod = this.filterFormData[ReportListFilterFields.GROUP_BY_DATE];
    },
    setActiveFiltersCount(count: number): void {
      this.activeFiltersCount = count;
    },
    setDefaultFilterFormData(): void {
      this.filterFormData = { ...DEFAULT_FILTER_FORM_DATA };
      this.submittedFilterFormData = { ...DEFAULT_FILTER_FORM_DATA };
      this.setActiveFiltersCount(1);
      this.setReportPeriod();
    },
    setSubmittedFilterFormData(): void {
      this.submittedFilterFormData = { ...this.filterFormData };
    },
    setFilterFormData(): void {
      const cleanedFilterData: ReportListFilter = {
        ...DEFAULT_FILTER_FORM_DATA,
        ...pickBy(this.filterFormData, (value) => value !== null && value !== '' && value !== undefined),
      };

      this.filterFormData = cleanedFilterData;
      this.setSubmittedFilterFormData();
      this.setActiveFiltersCount(this.filterFormDataLength);
      this.setIsFilterActive(this.filterFormDataLength > 1);
      this.setReportPeriod();
      this.setIsFilterVisible(false);
    },
    resetFilterFormData(): void {
      this.setDefaultFilterFormData();
      this.setActiveFiltersCount(this.filterFormDataLength);
      this.setIsFilterActive(false);
      this.setReportPeriod();
      this.setIsFilterVisible(false);
    },
  },
});
